const { APP_ROOT } = require('utils/constants/urls');

export const USEFUL_LINKS = {
  'For Patients': `${APP_ROOT}/patients/`,
};

export const PATIENT_CARE_CENTER = {
  name: 'PATIENT CARE CENTER',
  phone: '(888) 362-4321',
  content: 'If this is a healthcare emergency, please call 911',
};

export const MEDIA_INQUIRIES = {
  name: 'MEDIA INQUIRIES',
  email: 'media@everlywell.com',
};
